<ngx-spinner name="create-identity" [fullScreen]="false" bdColor="rgba(0,0,0,0.2)" type="ball-spin" size="default">
</ngx-spinner>
<h2 mat-dialog-title align="center">
    <b>
        {{ "REGISTER_IDENTITY.TITLE" | translate }}
    </b>
</h2>

<mat-dialog-content class="mat-typography content">
    <form [formGroup]="userForm">
        <mat-form-field>
            <mat-label>Email</mat-label>
            <input
                [id]="'input_registrar_username'"
                matInput
                maxlength="60"
                placeholder="ex, ben.kenobi@gurumatch.com"
                formControlName="username"
                username
                #username
                style="text-transform: lowercase"
                (change)="trimUserName()"
            />
            <mat-hint align="end"> {{ username.value.length }} / 60 </mat-hint>
            <mat-error *ngIf="userForm.invalid && userForm.hasError('required')">
                {{ "REGISTER_IDENTITY.USERNAME.REQUIRED" | translate }}
            </mat-error>
            <mat-error *ngIf="userForm.invalid && !userForm.hasError('required')">
                {{ "REGISTER_IDENTITY.USERNAME.INVALID" | translate }}
            </mat-error>
        </mat-form-field>

        <mat-form-field *ngIf="showFieldsUserName">
            <mat-label>{{ "REGISTER_IDENTITY.NAME" | translate }}</mat-label>
            <input id="input_name" matInput formControlName="name" required />
            <mat-error *ngIf="userForm.invalid && userForm.controls.name.hasError('required')">
                {{ "REGISTER_IDENTITY.REQUIRED" | translate }}
            </mat-error>
        </mat-form-field>

        <mat-form-field *ngIf="showFieldsUserName">
            <mat-label>{{ "REGISTER_IDENTITY.SURNAME" | translate }}</mat-label>
            <input id="input_surname" matInput formControlName="surname" required />
            <mat-error *ngIf="userForm.invalid && userForm.controls.surname.hasError('required')">
                {{ "REGISTER_IDENTITY.REQUIRED" | translate }}
            </mat-error>
        </mat-form-field>
    </form>

    <app-user-custom-fields
        #appUserCustomFields
        [fields]="userCustomFields$.value"
        [user]="user"
        [editMode]="true"
    ></app-user-custom-fields>

    <app-password-validator
        #appPasswordValidator
        [passwordRegex]="getPasswordRegex()"
        [passwordCustomRules]="getPasswordCustomRules()"
        (validValue)="validPassword($event)"
        (password)="password($event)"
    ></app-password-validator>
</mat-dialog-content>

<mat-dialog-actions align="end">
    <button mat-raised-button [mat-dialog-close]="false" *ngIf="!disableClose">
        {{ "REGISTER_IDENTITY.CANCEL" | translate }}
    </button>
    <button
        [id]="'button_Create_user'"
        mat-raised-button
        color="primary"
        (click)="Create()"
        [disabled]="
            userForm.invalid || !_validPassword || (appUserCustomFields?.form && appUserCustomFields.form.invalid)
        "
    >
        {{ "REGISTER_IDENTITY.CREATE" | translate }}
    </button>
</mat-dialog-actions>
